<app-form-input 
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="voie?.num" 
	[label]="step1.getnum"
	[type]="'text'"
	[rule]="'minSize_1|maxSize_50'"
	[name]="getUid()+'_SepAtt_num'">
</app-form-input>

<app-form-input 
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="voie?.typevoie" 
	[label]="step1.gettypevoie"
	[type]="'text'"
	[rule]="'required|minSize_1|maxSize_255'"
	[errorMessage]="{'required' : 'ctr_263'}"
	[name]="getUid()+'_SepAtt_typevoie'">
</app-form-input>

<!-- PRB0053517: indiquer au champ le nouveau controle à appliquer: minTexteLength_5 au lieu de minSize_5 -->
<app-form-input
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="voie?.nomvoie" 
	[label]="step1.getnomvoie"
	[type]="'text'"
	[rule]="'required|minTextLength_5|maxSize_1000'"
	[errorMessage]="{'required' : 'ctr_263', 'minTextLength' : 'ctr_10'}"
	[name]="getUid()+'_SepAtt_nomvoie'">
</app-form-input>
